import {EntityType} from "@ots-frontend/ots-data";
import {TFunction} from "i18next";

export const getEntityTypeDisplayValueAsString = (
  type: string,
  t: TFunction<"common"[], undefined, "common"[]>,
  plural = false
): string => {
  const props = getIntlProps(type, plural);
  return t(props.key, props.defaultValue)
};

const getIntlProps = (type: string, plural = false): { key: string, defaultValue: string } => {
  switch (type) {
    case "COMPANY":
      return {
        key: "ots.ui.entity.type.company",
        defaultValue: "Company"
      };
    case "COMPANY_UNIT":
      return {
        key: "common.entity.type.companyunit",
        defaultValue: "Company Unit"
      };
    case "CONCOMMIGLED":
      return {
        key: "ots.ui.entity.type.containercluster",
        defaultValue: "Container Cluster"
      };
    case "CONTAINER": {
      let key = "ots.ui.entity.type.container";
      if (plural) {
        key += ".plural";
      }

      let defaultValue = "Container";
      if (plural) {
        defaultValue = "Containers";
      }

      return {
        key,
        defaultValue
      };
    }
    case "DISPATCH":
      return {
        key: "ots.ui.entity.type.dispatch",
        defaultValue: "Dispatch"
      };
    case "DISPATCHREQUEST":
      return {
        key: "ots.ui.entity.type.dispatchrequest",
        defaultValue: "Dispatch Request"
      };
    case "DVIR": {
      let key = "common.entity.dvir";
      if (plural) {
        key += ".plural";
      }

      let defaultValue = "DVIR";
      if (plural) {
        defaultValue = "DVIRs";
      }

      return {
        key,
        defaultValue
      };
    }
    case "METER": {
      let key = "ots.ui.entity.type.meter";
      if (plural) {
        key += ".plural";
      }

      let defaultValue = "Meter";
      if (plural) {
        defaultValue = "Meters";
      }

      return {
        key,
        defaultValue
      };
    }
    case "OPERATINGAREA":
      return {
        key: "ots.ui.entity.type.operatingarea",
        defaultValue: "Operating Area"
      };
    case "PIPE": {
      let key = "ots.ui.entity.type.pipeline";
      if (plural) {
        key += ".plural";
      }

      let defaultValue = "Pipeline";
      if (plural) {
        defaultValue = "Pipelines";
      }

      return {
        key,
        defaultValue
      };
    }
    case "PERSON":
      return {
        key: "ots.ui.entity.type.person",
        defaultValue: "Person"
      };
    case "REGION": {
      let key = "ots.ui.entity.type.region";
      if (plural) {
        key += ".plural";
      }

      let defaultValue = "Region";
      if (plural) {
        defaultValue = "Regions";
      }

      return {
        key,
        defaultValue
      };
    }
    case "RIG":
      return {
        key: "ots.ui.entity.type.rig",
        defaultValue: "Rig"
      };
    case "ROUTE":
      return {
        key: "ots.ui.entity.type.route",
        defaultValue: "Route"
      };
    case "ROUTEGROUP":
      return {
        key: "ots.ui.entity.type.routegroup",
        defaultValue: "Route Group"
      };
    case "SERVICETYPE":
      return {
        key: "ots.ui.entity.type.servicetype",
        defaultValue: "Service Type"
      };
    case "SERVICETYPERULE": {
      let key = "ots.ui.entity.type.servicetyperule";
      if (plural) {
        key += ".plural";
      }

      let defaultValue = "Service Type Rule";
      if (plural) {
        defaultValue = "Service Type Rules";
      }

      return {
        key,
        defaultValue
      };
    }
    case "SITE":
      return {
        key: "ots.ui.entity.type.site",
        defaultValue: "Site"
      };
    case "TRANSPORTTRANSPORTASSOC":
      return {
        key: "ots.ui.entity.type.transporttransportassoc",
        defaultValue: "Ticket"
      };
    case "TRAILER":
      return {
        key: "ots.ui.entity.type.trailer",
        defaultValue: "Trailer"
      };
    case "VEHICLE":
      return {
        key: "ots.ui.entity.type.vehicle",
        defaultValue: "Truck"
      };
    case "WATERTYPE":
      return {
        key: "ots.ui.entity.type.freighttype",
        defaultValue: "Freight Type"
      };
    case "WELL":
      return {
        key: "ots.ui.entity.type.well",
        defaultValue: "Well"
      };
    case "WELLSTAGE": {
      let key = "ots.ui.entity.type.wellstage";
      if (plural) {
        key += ".plural";
      }

      let defaultValue = "Well Stage";
      if (plural) {
        defaultValue = "Well Stages";
      }

      return {
        key,
        defaultValue
      };
    }
    default:
      return {
        key: "ots.ui.shared.unknown",
        defaultValue: "Unknown"
      };
  }
};
